module.exports = __webpack_public_path__ + "static/app-mind-preview-1a3343907c30bb307d07f167a338ad7e.png";